// Tarot Card Deck example by Dr. Derek Austin 🥳 (Github master)
// Credit Paul Henckel for the original code
// Source: https://codesandbox.io/s/j0y0vpz59?from-embed

import { render } from 'react-dom'
import React, { useState } from 'react'
import { useSprings, animated, interpolate } from 'react-spring'


function Deck(props) {

var cardPath = "cards/cover.jpg";
const galacticDeck = [];
for (var i=0;i<12;i++){
   galacticDeck.push(cardPath);
}

// These two are just helpers, they curate spring data, values that are later being interpolated into css
const to = i => ({ x: 0, y: i * -4, scale: 1, rot: 0, delay: i * 100 })
const from = i => ({ x: 0, rot: 0, scale: 1.5, y: -1200 })
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const trans = (r, s) => `perspective(calc(100vh)) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`

const cards = galacticDeck
const [gone] = useState(() => new Set()) // The set flags all the cards that are flicked out
const [springs, set] = useSprings(cards.length, i => ({ ...to(i), from: from(i) })) // Create a bunch of springs using the helpers above
/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 * Updated for EC6/ECMA2015
 * source: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
 */

  // Create a gesture, we're interested in down-state, delta (current-pos - click-pos), direction and velocity
  // Now we're just mapping the animated values to our view, that's it. Btw, this component only renders once. :-)
  var cardDeck = springs.map(({ x, y, rot, scale }, i) => (
    <animated.div className="shufflecards"  key={i} style={{ width:`${props.width}`, transform: interpolate([x, y], (x, y) => `translate3d(${x}px,${y}px,0)`) }}>
      {
        // This is the card itself, we're binding our gesture to it (and inject its index so we know which is which)
      }
      <animated.div className="shufflecard" style={{ transform: interpolate([rot, scale], trans), backgroundImage: `url(${cards[i]})`, width:`${props.width}`, height:`${props.height}`}} />
    </animated.div>
  ))

return (<div className="carddeck">{cardDeck}</div>);

};

export default Deck;
